import { getSigV4HeadersForGet, isExpiredToken } from '@/utils/cognito';
import { ApiUrl } from '@/utils/constants';
import api from '@/utils/api';
import url from '@/utils/config';
import { useSetRecoilState } from 'recoil';
import alertState from '@/states/alertState';
import useSetLoading from '../useSetLoading';

/**
 * 「ドキュメントダウンロード関連」のフック処理を実施する。
 * @returns フック処理
 */
const useDocumentDownload = () => {
  // ローディング
  const { startLoading, finishLoading } = useSetLoading();

  // アラート
  const setAlert = useSetRecoilState(alertState);

  /**
   * 「契約書面」の取得処理を実施する。
   * @param pathname 契約書面の取得パス名称
   * @returns なし
   */
  const executeDownloadContract = async (pathname: string) => {
    if (!pathname) {
      // 対象ファイルが無い場合は API を呼ばずに終了する。
      return;
    }
    try {
      startLoading(ApiUrl.Read.DOWNLOAD_CONTRACT);

      const apiUrl = `${ApiUrl.Read.DOWNLOAD_CONTRACT}/${pathname}`;
      const headers = await getSigV4HeadersForGet(apiUrl);
      const { data } = await api.get(apiUrl, headers);

      // クライアント側でダウンロード処理を実施する。
      // APIは base64 のPDF本体を返すため、Blobへ変換してブラウザダウンロードさせる。
      const buffer = Buffer.from(data.data, 'base64');
      const blob = new Blob([buffer], { type: 'application/pdf' });
      const downloadUrl = URL.createObjectURL(blob);
      const download = document.createElement('a');
      download.href = downloadUrl;
      download.download = data.file_name;
      download.click();
      // 一時URLを破棄して不要なリソース保持を避ける。
      (window.URL || window.webkitURL).revokeObjectURL(downloadUrl);
    } catch (error: any) {
      if (isExpiredToken(error)) {
        // 認証切れではファイル取得を継続できないためログインへ戻す。
        window.location.href = url('/login');
        sessionStorage.clear();
        return;
      }
      // ダウンロード失敗は共通アラートで通知する。
      setAlert({
        isOpen: true,
        apiType: '',
      });
    } finally {
      finishLoading(ApiUrl.Read.DOWNLOAD_CONTRACT);
    }
  };
  return { executeDownloadContract };
};

export default useDocumentDownload;
